import * as React from 'react'

function SvgCheckmarkBubble(props, svgRef) {
  return (
    <svg viewBox="0 0 67 67" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        d="M45.317 18.098l-15.075 14.97-7.512-7.642a1.046 1.046 0 10-1.48 1.48l8.364 8.374c.204.204.47.306.74.306s.536-.102.74-.306l15.703-15.586a1.046 1.046 0 000-1.48c-.407-.522-1.061-.522-1.48-.116zM58.507 0H8.257C3.645 0-.118 3.762-.118 8.257v37.57c0 4.613 3.763 8.257 8.375 8.257H20.82V64.96c0 1.387.89 2.041 1.714 2.041.31 0 .626-.098.91-.304l16.344-12.262H58.63c4.613 0 8.375-3.762 8.375-8.257V8.257C66.882 3.762 63.231 0 58.507 0zm6.282 45.945c0 3.462-2.818 6.163-6.282 6.163H38.97l-16.056 12.05v-12.05H8.257c-3.464 0-6.28-2.817-6.28-6.163V8.375c0-3.463 2.816-6.163 6.28-6.163h50.25c3.464 0 6.282 2.817 6.282 6.163v37.57z"
        fill="#204667"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgCheckmarkBubble)
export default ForwardRef
